const root = 'retailerSubscriptionBox'

export const TestId = {
  button: `${root}-button`,
  currentPlanText: `${root}-currentPlanText`,
  currentPlanProductLimit: `${root}-currentPlanProductLimit`,
}
